import React from 'react';
import styled from 'styled-components';
import { Box, BoxProps as MuiBoxProps, fade } from '@material-ui/core';
import { RoundedCard } from '../style';

interface BoxProps extends Omit<MuiBoxProps, 'justifyContent' | 'alignItems' | 'display'> {
    color?: 'blue' | 'purple' | 'orange' | 'green';
}

export const CircleIcon = styled(
    ({ color, ...props }: BoxProps) => <Box display='flex' justifyContent='center' alignItems='center' {...props} />
)`
    border-radius: 50%;
    ${({ theme, color }) => `
        background-color: ${color ? fade(theme.palette.additional[color], 0.16) : fade(theme.palette.primary.main, 0.16)};
        color: ${color ? theme.palette.additional[color] : theme.palette.primary.main};
    `}
    font-size: ${({ fontSize, theme }) => fontSize || theme.typography.fontSize }px;
`;

export const CheckDeliveryListWrapper = styled.div`
    display: grid;
    gap: ${({ theme }) => theme.spacing(2.5)}px 0;
`;

export const CheckDeliveryItemsWrapper = styled.div`
    display: grid;
    gap: 20px 0;
    width: 100%;
    max-height: calc(100vh - 352px);
    overflow-y: scroll;
    padding-bottom: 20px;
`;

export const CheckDeliveryItemWrapper = styled(RoundedCard)`
    display: grid;
    grid-template-columns: 1fr 2fr;
`;

export const Divider = styled.div`
    height: 2px;
    ${({ theme }) => `
        background-color: ${fade(theme.palette.primary.main, 0.16)};
        border-radius: ${theme.shape.borderRadius};
    `}
`;